/**
 * Created by idea on 04/04/2017.
 */
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/startWith';
import { Injectable } from '@angular/core';
import { Actions, Effect, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticateService } from '../services/Authenticate.service';
import { ModalInfoService } from '../services/ModalInfo.service';
import * as authen from '../actions/authentication';
import { FlashMessagesService } from 'angular2-flash-messages';

/**
 * Effects offer a way to isolate and easily test side-effects within your
 * application.
 * The `toPayload` helper function returns just
 * the payload of the currently dispatched action, useful in
 * instances where the current state is not necessary.
 *
 * Documentation on `toPayload` can be found here:
 * https://github.com/ngrx/effects/blob/master/docs/api.md#topayload
 *
 * If you are unfamiliar with the operators being used in these examples, please
 * check out the sources below:
 *
 * Official Docs: http://reactivex.io/rxjs/manual/overview.html#categories-of-operators
 * RxJS 5 Operators By Example: https://gist.github.com/btroncone/d6cf141d6f2c00dc6b35
 */

@Injectable()
export class AuthEffects {

    @Effect() login$ = this.actions$
        // Listen for the 'LOGIN' action
        .ofType(authen.ActionTypes.LOGIN)
        // Map the payload into JSON to use as the request body
        .map(action => action.payload)
        .switchMap(
            payload => this.authenService.login(payload)
                // If successful, dispatch success action with result
                .map(res => {
                    let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
                    let url = '/dashboard';
                    if (returnUrl) {
                        url = returnUrl;
                    }

                    this.router.navigate([url]);

                    return new authen.LoginSuccessAction(res.token);
                })
                // If request fails, dispatch failed action
                .catch((err) => {
                    this._flashMessagesService.show(err.message, { cssClass: 'alert-danger', timeout: 8000 });
                    return Observable.of(new authen.LoginFailAction([]))
                })
        );

    @Effect() logout$ = this.actions$
        // Listen for the 'LOGIN' action
        .ofType(authen.ActionTypes.LOGOUT)
        // Map the payload into JSON to use as the request body
        .map(action => action.payload)
        .switchMap(() => Observable.of(this.authenService.logout())
            // If successful, dispatch success action with result
            .map(res => {
                return new authen.LoginFailAction([]);
            })
            // If request fails, dispatch failed action
            .catch(() => Observable.of(new authen.LoginFailAction([])))
        );

    constructor(private actions$: Actions,
        private authenService: AuthenticateService,
        private router: Router,
        private route: ActivatedRoute,
        private mdInfo: ModalInfoService,
        private _flashMessagesService: FlashMessagesService) {
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/effects/user.ts